// src/pages/Unauthorized.js
export default function Unauthorized() {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>🚫 Accès interdit</h1>
      <p>Vous n’avez pas la permission d’accéder à cette page.</p>
    </div>
  );
}
